var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    height: 222.89,
    viewBox: "0 0 311 222.88666",
    width: 311,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 -225.72 606.44)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(.40790 0 0 .40790 180.58 234.47)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m258.1 375.53h53.552l-28.368 84.597-25.184-84.597",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m588.51 198.87h-283.53v72.677l31.727 9.7361-10.246 31.035h-85.648l-11.014-30.976 34.398-9.7944v-72.677h-242.75v72.677l40.302 9.8454 95.477 211.52-50.424 12.823v87.385h396.36v-87.409l-50.898-12.799 94.304-211.52 41.941-9.8454v-72.677zm-26.685 100.97-79.579 178.5 42.366 10.652v125.58h-439.26v-125.51l41.81-10.63-80.655-178.68-46.505-11.36v-110.96h609.96v111.12l-48.13 11.298",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m485.79 221.58-27.506 20.871-27.433-19.871 10.642 31.482-25.903 20.798h32.198l10.496 30.039 10.496-30.039h33.466l-26.62-21.116 10.164-32.164zm-112.26 139.36h32.149l10.559 30.061 10.433-30.061h33.504l-26.649-21.131 10.198-32.149-27.487 20.852-27.506-19.885 10.691 31.516-25.893 20.798zm-41.009 88.402h32.205l10.506 30.051 10.47-30.051h33.483l-26.663-21.148 10.164-32.142-27.453 20.866-27.487-19.81 10.654 31.452-25.879 20.781zm-29.473 34.979 10.654 31.423-25.784 20.789h32.125l10.535 30.095 10.445-30.095h33.517l-26.685-21.099 10.183-32.176-27.46 20.871-27.53-19.807zm-44.946-108.79 25.184 84.597 28.368-84.597h-53.552zm194.17 117.39 50.898 12.799v87.409h-396.36v-87.385l50.424-12.823-95.477-211.52-40.302-9.8454v-72.677h242.75v72.677l-34.398 9.7944 11.014 30.976h85.648l10.246-31.035-31.727-9.7361v-72.677h283.53v72.677l-41.941 9.8454-94.304 211.52",
    fill: "#ce1126"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m347.85 515.43 26.685 21.099h-33.517l-10.445 30.095-10.535-30.095h-32.125l25.784-20.789-10.654-31.423 27.53 19.807 27.46-20.871-10.183 32.176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.23 416.92 27.453-20.866-10.164 32.142 26.663 21.148h-33.483l-10.47 30.051-10.506-30.051h-32.205l25.879-20.781-10.654-31.452 27.487 19.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.24 328.51 27.487-20.852-10.198 32.149 26.649 21.131h-33.504l-10.433 30.061-10.559-30.061h-32.149l25.893-20.798-10.691-31.516 27.506 19.885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m468.78 274.86-10.496 30.039-10.496-30.039h-32.198l25.903-20.798-10.642-31.482 27.433 19.871 27.506-20.871-10.164 32.164 26.62 21.116h-33.466"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfcLogo);
export default __webpack_public_path__ + "static/media/afc_logo.fa3f0705d90b537928daadabcbc6831d.svg";
export { ForwardRef as ReactComponent };